import { get, set, assign, cloneDeep, isNil, isEmpty, omitBy, omit, isNumber, map, chunk, isArray, isBoolean } from 'lodash'

const isReallyEmpty = (x) => (isNil(x) || (!isNumber(x) && !isBoolean(x) && isEmpty(x)))

export const encodeQueryData = (data) => {
  const ret = map(data, (value, key) => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(value)
  })
  return ret.join('&')
}

export const mapProperties = function (objName, names, mutationName, mutationPayloadAttrName) {
  let result = {}

  names.map(function (item) {
    result[item] = {
      get () {
        return get(this, `${objName}.${item}`)
      },
      set (value) {
        const newObj = assign({}, this[objName], set({}, item, value))
        this.$store.commit(mutationName, set({}, mutationPayloadAttrName, newObj))
      }
    }
  })

  return result
}

export const mapStateObjectProps = function ({ stateName, objectName, properties, mutationName, payloadAttrName }) {
  const result = {}

  properties.map(function (item) {
    set(result, item, {
      get () {
        return stateName ? get(this.$store.state, `${stateName}.${item}`) : get(this, `${objectName}.${item}`)
      },
      set (value) {
        const object = stateName ? get(this.$store.state, stateName) : get(this, objectName)
        const data = cloneDeep(assign({}, object, set({}, item, value)))
        this.$store.commit(mutationName, set({}, payloadAttrName, data))
      }
    })
  })
  return result
}

export const transformPlan = function (tree) {
  if (tree) {
    return { initialStep: (function recurse (currentStep) {
      let json = cloneDeep(omit(currentStep, 'input', 'step', 'id', 'parentId'))
      const tmp = {
        Hangup: {
          type: 'SimpleAction',
          action: 'hangup'
        },
        Begin: {
          type: 'SimpleAction',
          action: 'begin'
        },
        Return: {
          type: 'SimpleAction',
          action: 'return'
        },
        Repeat: {
          type: 'SimpleAction',
          action: 'repeat'
        }
      }[json.type]
      if (tmp) assign(json, tmp)
      if (currentStep.step) {
        json.step = recurse(currentStep.step)
      } else if (currentStep.input) {
        json.input = omit(currentStep.input, 'choices')
        json.input.choices = currentStep.input.choices.map(recurse)
      }
      return omitBy(json, isReallyEmpty)
    })(tree.initialStep)}
  }
}

export const paginateList = function (mainList, currentPage, size) {
  const arry = chunk(mainList, size)
  let current = currentPage
  if (arry.length < current) {
    current = arry.length
  }
  return { result: arry[current - 1], currentPage: current }
}

export const setNullIfEmpty = function (obj, props, zero = true) {
  if (obj && isArray(props)) {
    for (let prop of props) {
      obj[prop] = obj[prop] === '' || (zero && obj[prop] === 0) ? null : obj[prop]
    }
  }
}

export const pMap = function (iterable, mapper, options) {
  return new Promise((resolve, reject) => {
    options = Object.assign({
      concurrency: Infinity
    }, options)

    if (typeof mapper !== 'function') {
      throw new TypeError('Mapper function is required')
    }

    const {concurrency} = options

    if (!(typeof concurrency === 'number' && concurrency >= 1)) {
      throw new TypeError(`Expected \`concurrency\` to be a number from 1 and up, got \`${concurrency}\` (${typeof concurrency})`)
    }

    const ret = []
    const iterator = iterable[Symbol.iterator]()
    let isRejected = false
    let isIterableDone = false
    let resolvingCount = 0
    let currentIndex = 0

    const next = () => {
      if (isRejected) {
        return
      }

      const nextItem = iterator.next()
      const i = currentIndex
      currentIndex++

      if (nextItem.done) {
        isIterableDone = true

        if (resolvingCount === 0) {
          resolve(ret)
        }

        return
      }

      resolvingCount++

      Promise.resolve(nextItem.value)
      .then(element => mapper(element, i))
      .then(
        value => {
          ret[i] = value
          resolvingCount--
          next()
        },
        error => {
          isRejected = true
          reject(error)
        }
      )
    }

    for (let i = 0; i < concurrency; i++) {
      next()

      if (isIterableDone) {
        break
      }
    }
  })
}

const symbolEnd = Symbol('pForever.end')
const pForever = async (fn, previousValue) => {
  const newValue = await fn(await previousValue)
  if (newValue === symbolEnd) {
    return
  }
  return pForever(fn, newValue)
}

pForever.end = symbolEnd

export {pForever}

export const countries = [
  { name: 'USA', code: 'US' },
  { name: 'Colombia', code: 'CO' },
  { name: 'México', code: 'MX' }
]

export const countries2 = [
  { name: 'Colombia', code: 'CO' },
  { name: 'México', code: 'MX' },
  { name: 'Costa Rica', code: 'CR' },
  { name: 'Honduras', code: 'HN' },
  { name: 'República Dominicana', code: 'DO' },
  { name: 'Panamá', code: 'PA' },
  { name: 'Perú', code: 'PE' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'USA', code: 'US' }
]



// WEBPACK FOOTER //
// ./src/utils.js